module.exports = __webpack_public_path__ + "static/media/uws_logo.52549d1d.svg";